import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "us-west-2",
    aws_cognito_identity_pool_id: "us-west-2:8933d30f-0610-4b8d-9ec8-afa52ad0f4fe",
    aws_user_pools_id: "us-west-2_jr0syLccm",
    aws_user_pools_web_client_id: "1kekc4q2fahbp7em8866m597pm",
    Auth: {
      identityPoolId: "us-west-2:8933d30f-0610-4b8d-9ec8-afa52ad0f4fe",
      region: "us-west-2",
      userPoolId: "us-west-2_jr0syLccm",
      userPoolWebClientId: "1kekc4q2fahbp7em8866m597pm",
    },
    oauth: {
      domain: "whs-safer-beta-latam.auth.us-west-2.amazoncognito.com",
      redirectSignIn: "https://beta.latam.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.latam.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve beta to "test".
  const stage = "beta".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
